import React, { forwardRef } from 'react';
import '../questionnaire-reset.css';

interface QuestionnaireWrapperProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Wrapper component that applies CSS reset to isolate questionnaire components
 * from global Chakra UI/Emotion styles, ensuring Tailwind CSS works properly.
 */
export const QuestionnaireWrapper = forwardRef<HTMLDivElement, QuestionnaireWrapperProps>(
  ({ children, className = '' }, ref) => {
    return (
      <div ref={ref} className={`questionnaire-reset ${className}`}>
        {children}
      </div>
    );
  }
);

QuestionnaireWrapper.displayName = 'QuestionnaireWrapper';

export default QuestionnaireWrapper;
